
const useUiState = () => {

  const {
    isComplementarySidebarOpen: isSidebarOpen,
    setIsComplementarySidebarOpen,
  } = useComplementarySidebarStore();
  const { isExtraGuaranteeOpen, setIsExtraGuaranteeOpen } = useExtraGuaranteeSidebarStore();
  const { isComplementarySidebarEnabled } = useStoreVsfExtended();
  const { isFilterModalOpen, setFilterModalOpen } = useFilterModalUiStore();

  const isComplementarySidebarOpen = computed(() =>
    isSidebarOpen.value && isComplementarySidebarEnabled.value);

  const toggleFilterModal = () => {

    setFilterModalOpen(!isFilterModalOpen.value);
  
  };

  const toggleComplementarySidebar = () => {

    setIsComplementarySidebarOpen(!isSidebarOpen.value);
  
  };

  const toggleExtraGuarantee = () => {

    setIsExtraGuaranteeOpen(!isExtraGuaranteeOpen.value);
  
  };

  return {
    isFilterModalOpen,
    toggleFilterModal,
    isExtraGuaranteeOpen,
    toggleExtraGuarantee,
    isComplementarySidebarOpen,
    toggleComplementarySidebar,
  };

};

export default useUiState;
